module.exports = __webpack_public_path__ + "media/images/signatures/sara_black-6f6fc5e1083e41cdc9e68a0216165748.jpg";